module.exports = "/_next/static/images/qq-dc95976d.png";